/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import $ from 'jquery';
import TagManager from 'react-gtm-module';

function Caption02() {
	let location = useLocation();
	const tagManagerArgs = {
		gtmId: 'GTM-NDBLPCX'
	}
	TagManager.initialize(tagManagerArgs);
	useEffect(() => {
		//$(".btn_popup").off('click');
		//$(".btn_close").off('click');
		$(".btn_popup").on('click', function () {
			$(".popup").hide();
			var href = "#" + $(this).attr('id');
			$(href).show();
		})
		$(".btn_close").on('click', function () {
			$(".popup").hide();
		});
	}, [location])

	return (
		<>
			<div className="popup" id="cb_pop19">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">智慧家電</div>
								<h4 className="cb_19">MOD</h4>
								<p>「MOD」是中華電信推出的多媒體內容傳輸平台服務，透過雙向寬頻網路（如中華電信ADSL非固定制及光世代網路），將電視頻道、隨選電影與連續劇等多樣內容，透過MOD機上盒呈現在家中原本的電視機上。現在可透過i寶貝聲控開、關、選台及快速搜尋影片等，滿足您動口不動手輕鬆隨選的需求！</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，我要看公視</span></p></li>
									<li><p><span>i寶貝，「MOD」大聲一點</span></p></li>
									<li><p><span>i寶貝，「MOD」調小聲</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop21">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">智慧家電</div>
								<h4 className="cb_21">聲控智慧家電</h4>
								<p>使用語音指令控制家中的智慧聯網家電，例如：冷氣、空氣清淨機、除溼機、掃地機器人等 (更多聲控指令及支援的家電廠牌及型號請參閱官網「智慧設備」清單)。</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，打開冷氣(支援台語)</span></p></li>
									<li><p><span>i寶貝，關閉冷氣(支援台語)</span></p></li>
									<li><p><span>i寶貝，冷氣溫度調16~30度</span></p></li>
									<li><p><span>i寶貝，冷氣風速設定自動</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="popup" id="cb_pop22">
				<div className="pagesize">
					<div className="popup_box pb_big caption_txt">
						<a className="btn_close"></a>
						<div className="popup_txt">
							<div className="cb_type">
								<div className="cb_tag">智慧家電</div>
								<h4 className="cb_22">i寶車</h4>
								<p>「腳步不曾停下，因為我有千里馬(i寶車)」，放上車子，我是家人的最佳導遊，回到家裡，我自己也是鄉里間的里長伯，我的人生腳步，可以走的更長遠，因為我有千里馬，「千里人生，自己掌舵」！</p>
							</div>
							<div className="cb_tit">使用範例</div>
							<div className="cb_dialog">
								<ul>
									<li><p><span>i寶貝，爸爸的車在哪裡</span></p></li>
									<li><p><span>i寶貝，爸爸的車電量剩多少</span></p></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="content_inpage">
				<div className="pagesize">
					<ul className="bread">
						<li><a href="/">首頁</a></li>
						<li><a href="/container/caption">服務說明</a></li>
					</ul>
					<div className="tab_con">
						<div className="tab_box active">
							<h2 className="tit_main">服務說明 - 智慧家電</h2>
							<div className="content_box caption_box">
								<div className="content_box caption_box">
									<div className="cb_item flex_set">
										<div className="cb_box flex_box"><a id="cb_pop19" className="btn_popup cb_19">MOD</a></div>
										<div className="cb_box flex_box"><a id="cb_pop21" className="btn_popup cb_21">聲控智慧家電</a></div>
										<div className="cb_box flex_box"><a id="cb_pop22" className="btn_popup cb_22">i 寶車</a></div>
									</div>
									<div className="cb_dialog">
										<ul>
											<li className="flex_set cb_19"><p className="flex_box"><span>i寶貝，我要看公視。</span></p></li>
											<li className="flex_set cb_21"><p className="flex_box"><span>i寶貝，打開冷氣(支援台語)。</span></p></li>
											<li className="flex_set cb_21"><p className="flex_box"><span>i寶貝，冷氣溫度調成25度。</span></p></li>
										</ul>
										<ul>
											<li className="flex_set cb_20"><p className="flex_box"><span>i寶貝，我回來了(開啟所有家電)。</span></p></li>
											<li className="flex_set cb_22"><p className="flex_box"><span>i寶貝，爸爸的車在哪裡?</span></p></li>
											<li className="flex_set cb_22"><p className="flex_box"><span>i寶貝，爸爸的車電量剩多少?</span></p></li>
										</ul>
									</div>
								</div>
							</div>
							<div className="btn_main btn_other">
								<Link to={"/container/caption/Caption0201"}>查看支援家電清單</Link>
								<a href="/container/mod" target="_blank">MOD專區</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default Caption02;